export default field => !!(field.settings && field.settings.isAdminField);
